<script src="upload-image.component.ts"></script>
@if (userImgSignal()) {
  <!-- User Case -->
  <div
    class="relative flex justify-content-center align-items-center bg-gray-50 border-circle w-{{ customWidthSignal() }} h-{{
      customHeightSignal()
    }}"
    (dragover)="onDragOver($event)"
    (drop)="onDrop($event)"
    [class.disabled-expired]="isButtonLocked()"
  >
    @if (loadingSignal()) {
      <p-skeleton shape="circle" [size]="customWidthSignal()" styleClass="border-circle" />
    } @else {
      @if (imgPathSignal()) {
        <img class=" {{ imageFitSignal() }} border-circle w-full h-full" [src]="conditionsPath()" alt="image-icon" />

        @if (!disabledSignal()) {
          <div
            class="absolute flex justify-content-center align-items-center bg-red-500 hover:bg-red-600 border-2 border-circle border-white w-2rem h-2rem cursor-pointer"
            style="top: 8px; right: 0"
            (click)="onDeleteImg()"
            (keyup.enter)="onDeleteImg()"
            tabindex="0"
          >
            <i class="pi pi-times text-white text-sm"></i>
          </div>
        }
      } @else {
        <img class="w-full h-full" src="assets/icons/icon-user.png" alt="user" />
        <input [id]="fileInputId" style="display: none" type="file" accept=".png, .jpg, .jpeg, .webp" (change)="onFileSelected($event)" />
        <div
          class="absolute flex justify-content-center align-items-center bg-gray-50 hover:bg-gray-100 border-2 border-circle border-white w-2rem h-2rem cursor-pointer"
          style="bottom: 8px; right: 0"
          [class.disabled-expired]="isButtonLocked()"
          (click)="onSelectFile()"
          (keyup.enter)="onSelectFile()"
          tabindex="0"
        >
          <img style="width: 0.875rem; height: 0.875rem" src="assets/icons/icon-pencil.png" alt="pencil" />
        </div>
      }
    }
  </div>
} @else {
  <!-- Other Case -->
  <div
    class="relative flex flex-column justify-content-center align-items-center gap-3 bg-bluegray-50
  border-2 border-dashed border-round-xl border-400 text-xs text-400 w-{{ customWidthSignal() }} h-{{ customHeightSignal() }}
  {{ imgPathSignal() ? '' : 'cursor-pointer' }}"
    (click)="onSelectFile()"
    (keyup.enter)="onSelectFile()"
    tabindex="0"
    (dragover)="onDragOver($event)"
    (drop)="onDrop($event)"
    [class.disabled-expired]="isButtonLocked()"
  >
    @if (loadingSignal()) {
      <p-skeleton [width]="customWidthSignal()" [height]="customHeightSignal()" styleClass="border-round-xl" />
    } @else {
      @if (imgPathSignal()) {
        <img class="{{ imageFitSignal() }} border-round-xl w-full h-full" [src]="s3BlobPath + imgPathSignal()" alt="image-icon" />
        @if (!disabledSignal()) {
          <div
            class="absolute flex justify-content-center align-items-center bg-red-500 hover:bg-red-600 border-2 border-circle border-white w-2rem h-2rem cursor-pointer"
            style="top: -12px; right: -12px"
            [class.disabled-expired]="isButtonLocked()"
            (click)="onDeleteImg()"
            (keyup.enter)="onDeleteImg()"
            tabindex="0"
          >
            <i class="pi pi-times text-white text-sm"></i>
          </div>
        }
      } @else {
        <img class="w-2rem h-2rem" src="assets/icons/icon-image.png" alt="image" />
        <input [id]="fileInputId" style="display: none" type="file" accept=".png, .jpg, .jpeg, .webp" (change)="onFileSelected($event)" />
        <div class="flex flex-column align-items-center">
          <p>{{ 'upload.image' | transloco }}</p>
          <p>
            {{ 'upload.support' | transloco }}
            <span class="text-primary">png jpg webp</span>
          </p>
        </div>
      }
    }
  </div>
}

<app-dialog-alert [dataDialog]="dialogSignal()" (OnHide)="onCloseDialogAlert()">
  @if (contentDescDialog()) {
    <div [innerHTML]="contentDescDialog()"></div>
  }
</app-dialog-alert>
